export const MAJOR_CITIES = [
  {
    display: 'Melbourne',
    url: 'melbourne-vic',
  },
  {
    display: 'Sydney',
    url: 'sydney-nsw-2000',
  },
  {
    display: 'Brisbane',
    url: 'brisbane-greater-region-qld',
  },
  {
    display: 'Perth',
    url: 'perth-wa-6000',
  },
];

const MINOR_CITIES = [
  {
    display: 'Adelaide',
    url: 'adelaide-sa-5000',
  },
  {
    display: 'Hobart',
    url: 'hobart-tas-7000',
  },
  {
    display: 'Canberra',
    url: 'canberra-greater-region-act',
  },
  {
    display: 'Darwin',
    url: 'darwin-greater-region-nt',
  },
];

export const CITIES = [
  ...MAJOR_CITIES,
  ...MINOR_CITIES,
];
